"use client";

import Picture from "@/components/ui-kit/Picture/Picture";

type HomepageHeroImageImagesProps = {
  pill: string;
};

const HomepageHeroImageImages = ({ pill }: HomepageHeroImageImagesProps) => (
  <Picture
    src={pill}
    alt=""
    role="presentation"
    width={442}
    height={442}
    loading="eager"
    className="mx-auto size-[220px] md:size-[340px] xl:size-[360px]"
  />
);

export default HomepageHeroImageImages;
